module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/new_preview-47fc44a5a0a4d1ac1c08cf175c5b1f2e.jpg";